module.exports = __webpack_public_path__ + "img/jo2.103f335d.png";